// extracted by mini-css-extract-plugin
module.exports = {"sectionReport":"CurrentMonthReport_sectionReport__b260W","sectionTitle":"CurrentMonthReport_sectionTitle__fkF3_","title":"CurrentMonthReport_title__1EY20"};